import * as React from 'react';

import t from '../../../application/translate';

const { Component } = React;

class Part02 extends Component {

  render() {

    return (
      <ul>
        <li>
          {t('howGetVisa/documents/doc02/text/part01')}
        </li>
      </ul>
    );
  }

}

export default Part02;



// WEBPACK FOOTER //
// ./src/components/VisaCheckingForm/accordionParts/Part02.js